import { LOGOUT, SESSIONLOGOUT } from './constants';

export const logOut = () => ({
  type: LOGOUT,
});
export const handleSessionLogout = () =>({
  type: SESSIONLOGOUT,
});
export default logOut;
